import axios from "axios";
import mem from "mem";
import { SERVER_URL_TOKEN } from "../services/services";
const queryString = require('query-string')

const refreshTokenFn = async () => {
     let refreshTokenLS = null

     try {
          const raw = localStorage.getItem('user')
          refreshTokenLS = raw ? JSON.parse(raw) : null
     } catch {
          localStorage.removeItem("user");
          return null
     }

     if (!refreshTokenLS?.r) {
          localStorage.removeItem("user");
          return null
     }

     const body = queryString['stringify']({
          client_id: 'sekaans-spa-client',
          client_secret: 'secret',
          refresh_token: refreshTokenLS.r,
          grant_type: 'refresh_token'
     })

     try {
          const res = await axios.post(SERVER_URL_TOKEN, body, {
               withCredentials: true
          })

          const accessToken = res.data.access_token
          const refreshToken = res.data.refresh_token

          if (!accessToken) {
               localStorage.removeItem("user");
               return null
          }

          localStorage.setItem('user', JSON.stringify({
               a: accessToken,
               r: refreshToken
          }))

          return accessToken;

     } catch (error) {
          localStorage.removeItem("user");
          return null
     }

}

const maxAge = 10000;

export const memoizedRefreshToken = mem(refreshTokenFn, {
     maxAge,
});
